module.exports = __webpack_public_path__ + "img/svg/user.ea410ae4f2478ac67f67742ec9ccff58.svg";